import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	space__list: 'mw/space/list',
	space__all: 'mw/space/all',
	space__add: 'mw/space/add',
	space__del: 'mw/space/del',
};

export const spaceApi = createApi({
	reducerPath: 'mw/spaceApi',

	endpoints: (builder) => ({
		spaceList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/space/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.space__list],
		}),
		spaceAll: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/space/all?${qs.stringify(body)}`,
			}),
			providesTags: [tags.space__all],
		}),
		spaceAdd: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/space/add',
				body,
				jsonType: true,
			}),
			providesTags: [tags.space__add],
		}),
		spaceDel: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/space/del',
				body,
				jsonType: true,
			}),
			providesTags: [tags.space__del],
		}),
	}),
});

export const {
	spaceList,
	spaceAll,
	spaceAdd,
	spaceDel,
} = spaceApi.endpoints;

export default spaceApi;